import { Component, OnInit } from '@angular/core';
import { LibraryService, Dropobj,MasterService } from '../services/index';

import { HttpClient } from '@angular/common/http';
import {WebcamImage} from 'ngx-webcam';
import {Subject, Observable} from 'rxjs';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
  providers:[LibraryService,MasterService]
})
export class MembersComponent implements OnInit { 

 // books: Book[];
  memberdetails:any[]=[];
  classdetails:any[]=[];
  issuedetails:any=[];
  closeResult: string;
  classes: Dropobj[];
  section: Dropobj[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  bkcopies='1';
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  private modalRef1: NgbModalRef;
  studentinfo:any={};
  arrgender=[{value:'M',name:'Male'},{value:'F',name:'Female'},{value:'O',name:'Other'}];
  arrmemtype=[{value:'S',name:'staff'},{value:'V',name:'visitor'}];
  arrstatus=[{name:'Active'},{name:'Inactive'},{name:'Old'}];
  arrmemrating:any=[];
    arrclass:any[]=[];
arrcourse:any[]=[];
arrclass1:any[]=[];
arrcourse1:any[]=[];
//objall:any={}
arrinst:any=[];
bloodgp:any=[];
staffmem:any[]=[];
objregdata:any={};
objstfdata:any={};
stumemdata:any={};
arractmember:any=[];
arrhrmdesg:any=[];
arraylist:any=[];
arrinstf:any=[];
arrinstu:any=[];
arrhrmdept:any=[];
issuedinfocnt:any={};
fileToUpload: File = null;
defclass:any=0;
defcorse:any=0;
defstat='Active'
fData: FormData = new FormData;
memid:any;
memstusave=false;
arrsec:any=[];
castecats=[];
blstudent:boolean=true;
blstaff:boolean=true;
alnwarival:boolean=true;


  constructor(private http: HttpClient,private mservice:MasterService, private liservice: LibraryService,private modalService: NgbModal) { }


  public webcamImage: WebcamImage = null;
  private trigger: Subject<void> = new Subject<void>();
  triggerSnapshot(): void {
   this.trigger.next();
  }
  handleImage(webcamImage: WebcamImage): void {
   console.info('Saved webcam image', webcamImage);
   this.webcamImage = webcamImage;
  }
   
  public get triggerObservable(): Observable<void> {
   return this.trigger.asObservable();
  }
  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openprint(content) {
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
    
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  openstdentmodal(content,cmd,objdata)
  {
    console.log('objdata',objdata);
    if(cmd=='insert')
    {
      this.objregdata={};
    //   this.getclases();
    // this.getcourses();
    this.masbloodgroup();
    this.getinstitute();
    this.mascastecat();
    this.objregdata.defgender='M';
    this.objregdata.memname='';
    this.objregdata.mobileno='';
    this.objregdata.emailid='';
    this.objregdata.fatname='';
    this.objregdata.fatmobile='';
    this.objregdata.address='';
    this.objregdata.city='';
    this.objregdata.pincode='';
    this.objregdata.oprtype='insert';
    this.objregdata.memcd='';
    this.objregdata.sbscrdt='';
    this.objregdata.expdt='';
    this.objregdata.memid='0';
    this.objregdata.dob='';
    this.objregdata.secid='1';
    this.objregdata.admno='';
    this.objregdata.status='active';
    this.objregdata.catid='1';
    this.objregdata.qinnm='';
    this.objregdata.qpct='';
    this.objregdata.ayid='0';

    }

    else if(cmd=='update')
    {
      debugger
      //this.getmemberdata('selstuid',objdata.stuid);
     
    this.masbloodgroup();
    this.getinstitute();
    this.mascastecat();
    this.objregdata.defgender=objdata.gender;
    this.objregdata.memname=objdata.memname;
    this.objregdata.mobileno=objdata.mobileno;
    this.objregdata.emailid=objdata.email;
    this.objregdata.fatname=objdata.fatname;
    this.objregdata.fatmobile=objdata.fatmobile;
    this.objregdata.address=objdata.address;
    this.objregdata.city=objdata.city;
    this.objregdata.pincode=objdata.pin;
    this.objregdata.oprtype='update';
    this.objregdata.memid=objdata.memid;
    this.objregdata.defclass=objdata.clid;
    this.objregdata.defblgrp=objdata.blgrp;
    this.objregdata.defcorse=objdata.crsid;
    this.objregdata.definst=objdata.clientid;
    this.objregdata.dob=objdata.dob;
    this.objregdata.memcd=objdata.memcd;
    this.objregdata.sbscrdt=objdata.sbscrdt;
    this.objregdata.expdt=objdata.expdt;
    this.objregdata.status=objdata.status;
    this.objregdata.secid=objdata.secid;
    this.objregdata.admno=objdata.admno;

    this.objregdata.catid=objdata.catid;
    this.objregdata.qinnm=objdata.qinnm;
    this.objregdata.qpct=objdata.qpct;
    this.objregdata.ayid=objdata.ayid;
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
    
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });

  }

  openstafmodal(content,cmd,objdata)
  {
    console.log('objdata',objdata);
    
    if(cmd=='insert')
    {
      this.objstfdata={};
      this.objstfdata.defgender='M';
      this.objstfdata.defmemtype='staff';
    this.masbloodgroup();
    this.getinstitute();
    this.mashrmdesig();
    this.mashrmdept();
    this.objstfdata.memname='';
    this.objstfdata.mobileno='';
    this.objstfdata.emailid='';
    this.objstfdata.fatname='';
    this.objstfdata.fatmobile='';
    this.objstfdata.address='';
    this.objstfdata.city='';
    this.objstfdata.pincode='';
    this.objstfdata.oprtype='insert';
    this.objstfdata.memid='0';
    this.objstfdata.memcd='';
    this.objstfdata.sbscrdt='';
    this.objstfdata.expdt='';
    this.objstfdata.status='active';

   

    }

    else if(cmd=='update')
    {
      debugger
      //this.getmemberdata('selstuid',objdata.stuid);
    
    this.masbloodgroup();
    this.getinstitute();
    this.mashrmdesig();
    this.mashrmdept();
    this.objstfdata.clid=null;
    this.objstfdata.crsid=null;
    this.objstfdata.defgender=objdata.gender;
    this.objstfdata.memname=objdata.memname;
    this.objstfdata.mobileno=objdata.mobileno;
    this.objstfdata.emailid=objdata.email;
    this.objstfdata.fatname=objdata.fatname;
    this.objstfdata.fatmobile=objdata.fatmobile;
    this.objstfdata.address=objdata.address;
    this.objstfdata.city=objdata.city;
    this.objstfdata.pincode=objdata.pin;
    this.objstfdata.oprtype='update';
    this.objstfdata.memid=objdata.memid;
    this.objstfdata.defblgrp=objdata.blgrp;
    this.objstfdata.definst=objdata.clientid;
    this.objstfdata.dob=objdata.dob;
    this.objstfdata.defmemtype=objdata.memtype;
    this.objstfdata.clid=objdata.clid;
    this.objstfdata.memcd=objdata.memcd;
    this.objstfdata.doj=objdata.doj;
    this.objstfdata.sbscrdt=objdata.sbscrdt;
    this.objstfdata.expdt=objdata.expdt;
    this.objstfdata.crsid=objdata.crsid;
    this.objstfdata.status=objdata.status;
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
    
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });

  }
  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9\+\-\ ]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
  Savememberstudent()
  {
console.log('objregdata',this.objregdata);
this.memstusave=true;
this.liservice.savememberstudent(this.objregdata)
.subscribe((result:any) => {

  alert (result.message);
console.log('arrinst',result);
this.memstusave=false;
if(result.status=='Success')
{
  let localmodref=this.modalRef;
  localmodref.close();
 // this.getmemberdetails('selstu','');
 this.studentclick();

}
else
{

}
}, error => {

  this.memstusave=false;
}
);
  
  }

  Savememberstaff()
  {
console.log('objregdata',this.objstfdata);
this.memstusave=true;
this.liservice.savememberstaff(this.objstfdata)
.subscribe((result:any) => {

  alert (result.message);
console.log('arrinst',result);
this.memstusave=false;
if(result.status=='Success')
{
  let localmodref=this.modalRef;
  localmodref.close();
  this.staffclick();

}
else
{

}
}, error => {

  this.memstusave=false;
}
);
  
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  ngOnInit(): void {
    
    this.getclases();
    this.getcourses();
    this.massection();
    this.masacyear();
    this.getmemberdetails('selstu',this.defstat,this.defclass,this.defcorse);
    //this.getclassdetails();
    this.memberdashcnts('dashcnts');
 
  }


  ciractivemembers()
  {
      this.liservice.Getdashboarddata('memactives')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-arractmember',resultArray) ;
      this.arractmember=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }


  overview_student(oprtype)
  {
      this.liservice.Getdashboarddata(oprtype)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-arractmember',resultArray) ;
      this.arrinstu=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

  
  overview_staff(oprtype)
  {
      this.liservice.Getdashboarddata(oprtype)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-arractmember',resultArray) ;
      this.arrinstf=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }


  clickoverview()
  {
    this.ciractivemembers();
    this.overview_staff('instute_staffact');
    this.overview_student('instute_studentact');
  }
  toggleActivation($event,tag){
    if(tag=='student')
    {
    if ($event.checked){
      this.overview_student('instute_studentact');
  
    }
  else
  {
    this.overview_student('instute_student');
  
  }
}

else if(tag=='staff')
{
if ($event.checked){
  this.overview_staff('instute_staffact');

}
else
{
this.overview_staff('instute_staff');

}
}

}
  

  getmemberdetails(oprtype,sertxt,clid,crid) {
    this.liservice.getmemberdetails(oprtype,sertxt,clid,crid)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            if(oprtype=='selstaf')
            {
            this.staffmem = resultArray;
            console.log('members-staffmem', this.staffmem);
            }
            else
            {
              this.memberdetails=resultArray;
            }
            
        },
        error => console.log("Error :: " + error)
        )
  }


  getmemberdata(oprtype,sertxt) {
    this.liservice.getmemberdetails(oprtype,sertxt,0,0)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.stumemdata = resultArray[0];
            
        },
        error => console.log("Error :: " + error)
        )
  }

  
  getmemberrating() {
    this.liservice.getmemberrating(this.defclass,this.defcorse)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.arrmemrating = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }


  memberdashcnts(oprtype) {
    this.liservice.getmemberdetails(oprtype,'',0,0)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.memberdash = resultArray[0];
            
        },
        error => console.log("Error :: " + error)
        )
  }

  exportrecord(oprtype){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"export/expmembers.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
  
     window.open(url,'','');
   }

   exportmemrate(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"export/expmemrating.php?clcd="+clcd+"&aycd="+aycd+"&crid="+this.defcorse+"&clid="+this.defclass;
  
     window.open(url,'','_blank');
   }

   exportcirhistory(){
    // this.isLoadingResult=true;
     var clcd=localStorage.getItem('clcd');
     var aycd=localStorage.getItem('aycd');
 
      var url=this.liservice.callurl+"export/expcirhistory.php?clcd="+clcd+"&aycd="+aycd+"&oprtype=issuedtomember&dtfrm=&dtto=&memid="+this.studentinfo.memid;
   
      window.open(url,'','_blank');
    }

    exportnodue(noc){
      // this.isLoadingResult=true;
       var clcd=localStorage.getItem('clcd');
       var aycd=localStorage.getItem('aycd');
   
        var url=this.liservice.callurl+"qrcode/nodue.php?clcd="+clcd+"&aycd="+aycd+"&memid="+this.studentinfo.memid+"&noc="+noc;
     
        window.open(url,'','_blank');
      }
  
  staffclick()
  {
    //alert('staff click');
    // this.staff=true;
    // this.student=false;
    this.getmemberdetails('selstaf',this.defstat,0,0);
  }


  studentclick()
  {
   // alert('student click');
    // this.staff=false;
    // this.student=true;
    this.getmemberdetails('selstu',this.defstat,this.defclass,this.defcorse);
  }


  getclassdetails() {
    this.liservice.getclassdetails()
        .subscribe(
        resultArray => {
            
            //this.classdetails = resultArray;
            console.log('class-result', resultArray);
            var autharr=resultArray;
            var farr= Array.from(new Set(autharr.map((item: any) => item.clname)));
            var auth=[];
          for(var i=0;i<farr.length;i++)
            {
              debugger
              let objval:any={};
              objval.label=farr[i]
              objval.value=farr[i];
              console.log('obj',objval);
              auth.push(objval);
              objval={};
            }

            this.classdetails = auth;
            console.log('class-result', this.classdetails);

                  },
                  error => console.log("Error :: " + error)
          )
  }


  getissueddetails(stuid) {
    this.liservice.getissuedbookdetails(stuid,'issuedbktomem')
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.issuedetails = resultArray;
            this.getissuedbookinfocnts(stuid);
          //issuedbktomem  
            
        },
        error => console.log("Error :: " + error)
        )
  }
 
  getissuedbookinfocnts(stuid) {
    this.liservice.getissuedbookinfocnts(stuid)
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.issuedinfocnt = resultArray[0];
          //issuedbktomem  
            
        },
        error => console.log("Error :: " + error)
        )
  }

  openissuedhisdialog(content,bookid,obj) {
    debugger
    this.studentinfo=obj;
    this.getissueddetails(bookid);
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  private getcourses() {

    this.liservice.getcourse()
  .subscribe((result:any) => {
  
  this.arrcourse=result;
  this.arrcourse1=result;
  this.arrcourse1.unshift({crid:"0",crnm:"ALL"});
 this.defcorse="0";
  //this.selclid=result[0].clid;
  console.log('arrcourse',result);
  
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }

  mascastecat() {
    this.mservice.mascastecat()
        .subscribe(
        resultArray => {
            console.log('castecats', resultArray);
            this.castecats = resultArray.filter(item => item.active==='Yes')
           
        },
        error => console.log("Error :: " + error)
        )
  }
  

  private massection() {

    this.mservice.massection()
  .subscribe((result:any) => {
  
  this.arrsec=result;
  
  //console.log('arrcourse',result);
  
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }

  masbloodgroup() {
    this.liservice.masbloodgroups()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.bloodgp = resultArray;
           // this.objregdata.defblgrp=resultArray[0].blgpnm;
            //this.objstfdata.defblgrp=resultArray[0].blgpnm;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  printidcard(memid,type,tag){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"qrcode/"+type+".php?clcd="+clcd+"&aycd="+aycd+"&memid="+memid+"&clid="+this.defclass+"&crid="+this.defcorse+"&tag="+tag;
  
     window.open(url,'','_blank');
   }


   printidcardbulk(clid,crid){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"qrcode/idcard_Bulk.php?clcd="+clcd+"&aycd="+aycd+"&clid="+clid+"&crid="+crid;
  
     window.open(url,'','_blank');
   }
 protected mashrmdesig() {
    this.mservice.sel_sp_hrmdesig()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrhrmdesg = resultArray;
          //  this.objstfdata.clid=resultArray[0].desid;
            //this.objstfdata.defblgrp=resultArray[0].blgpnm;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  protected mashrmdept() {
    this.mservice.get_hrmdept()
        .subscribe(
        resultArray => {
            console.log('dept', resultArray);
            this.arrhrmdept = resultArray;
           //this.objstfdata.crsid=resultArray[0].depid;
            //this.objstfdata.defblgrp=resultArray[0].blgpnm;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  private getinstitute() {

    this.liservice.getinstite()
  .subscribe((result:any) => {
  
  this.arrinst=result;
  // this.objregdata.definst=result[0].instid;
  // this.objstfdata.definst=result[0].instid;
  //this.selclid=result[0].clid;
  console.log('arrinst',result);
  
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }
  
  private getclases() {

    this.liservice.getlibclasses()
.subscribe((result:any) => {

this.arrclass=result;
this.arrclass1=result;
this.arrclass1.unshift({clid:"0",clnm:"ALL"});
this.defclass="0";
//this.selclid=result[0].clid;
console.log('arrclass',result);


}, error => {


}
);




  }

  rankclick()
  {
    this.defclass='0';
    this.defcorse='0';
    this.getmemberrating();
  }


  private masacyear() {

    this.mservice.masacyear()
.subscribe((result:any) => {

this.arraylist=result;

console.log('arrclass',result);


}, error => {


}
);




  }
 
  openinfo(content,bkid)
{

  this.memid=bkid;
  this.modalOptions={size:'sm'};
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

opencam(content)
{

 // this.memid=bkid;
  this.modalOptions={size:'lg'};
  this.modalRef1=this.modalService.open(content,this.modalOptions);
  
  this.modalRef1.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

  upload(files: FileList) {
    debugger;
    this.fileToUpload = files.item(0);
  
    this.fData.append("bkid", this.memid.toString());
    //this.fData.append("docpurpose", "Studentphoto");
  
    // this.SService.uploadFile(fData).subscribe(
    //     response => this.handleResponse(response),
    //     error => this.handleError(error)
    // )
  }

  handleCapturedImage() {
   
    const arr = this.webcamImage.imageAsDataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], this.memid+'.jpg', { type: 'jpg' });
    console.log('file data',file); 


   // console.log('file data',JSON.stringify(this.fileToUpload));
  
  this.liservice.uploadmemberphoto(file,this.memid)
  .subscribe(fresult => {
     // console.log('ret',JSON.stringify(fresult));
      alert (fresult.message);
      if(fresult.status=='Success')
  {
    this.modalRef1.close();
  let localmodref=this.modalRef;
  localmodref.close();
  
  //this.Refreshsummary();
  //file={};
  }
      
  }, error => 
  alert('error in connection')
  
  );
  
  
  }
  
  
  fileupload()
  {
  debugger
  
  console.log('file data',JSON.stringify(this.fileToUpload));
  
  this.liservice.uploadmemberphoto(this.fileToUpload,this.memid)
  .subscribe(fresult => {
     // console.log('ret',JSON.stringify(fresult));
      alert (fresult.message);
      if(fresult.status=='Success')
  {
  let localmodref=this.modalRef;
  localmodref.close();
  //this.Refreshsummary();
  this.fileToUpload=null;
  }
      
  }, error => 
  alert('error in connection')
  
  );
  
  
  
  }
}
